<template>
    <div>
        <b-container>
            <h2>Instagram Account Coach</h2>
            <p>Get actionable suggestions on what works the best <strong>specifically for your audience</strong>.</p>
            <p><strong>Create a new report to learn:</strong></p>
            <ul class="fa-ul">
                <li><font-awesome-icon :icon="['fas', 'check']" class="fa-li text-success" /> Which hashtags should I be using but have not used yet?</li>
                <li><font-awesome-icon :icon="['fas', 'check']" class="fa-li text-success" /> How many hashtags to use to maximize discoverability without decreasing engagement?</li>
                <li><font-awesome-icon :icon="['fas', 'check']" class="fa-li text-success" /> Should I put hashtags in comments or in the caption?</li>
                <li><font-awesome-icon :icon="['fas', 'check']" class="fa-li text-success" /> What objects in the photos make the posts more popular?</li>
                <li><font-awesome-icon :icon="['fas', 'check']" class="fa-li text-success" /> What colors in the photos increase engagement?</li>
                <li>... and many more widgets with actionable advice</li>
            </ul>
            <p>
                <instagram-modal @created="reload"/>
                &nbsp;
                <b-btn
                        variant="outline-primary"
                        to="/instagram-coach-reports/e0a9b346-9e31-476c-b275-9ef450535436"
                >
                    <i class="far fa-file-alt"></i> View sample report
                </b-btn>
            </p>
            <div  v-if="getInstagramReports.length == 0" class="try-me-out">
                    <img class="arrow-top" src="https://cdn.ritekit.com/assets/img/common/arrow-signup.png">
                    Check me out!
                </div>
            <br>
            <h5 v-if="getInstagramReports.length > 0">Purchased Reports</h5>
            <b-table
                    v-if="getInstagramReports.length > 0"
                    :items="getInstagramReports"
                    :fields="reportTableFields"
                    class="hide-header vertical-align-middle"
                    :responsive="true"
            >
                <template v-slot:cell(account)="data">
                    <button class="btn btn-link" @click="openReport(data.item.uuid)" v-if="data.item.status==='done'">
                        <strong>@{{ data.item.instagramName }}</strong>
                    </button>
                    <span v-else>@{{ data.item.instagramName }}</span>
                </template>
                <template v-slot:cell(time_interval)="data">
                    {{ data.item.start | formatDate }} - {{ data.item.end | formatDate }}
                </template>
                <template v-slot:cell(price)="data">
                    ${{ data.item.price}}
                </template>
                <template v-slot:cell(status)="data">
                    <b-badge pill variant="success" v-if="data.item.status=='done'">
                        {{ data.item.status | capitalize }}
                    </b-badge>
                    <b-badge pill variant="warning" v-else>
                        {{ data.item.status | capitalize }}
                    </b-badge>
                </template>
                <template v-slot:cell(publish)="data">
                    <div class="text-right">
                        <b-btn
                                v-if="!data.item.published && data.item.status == 'done'"
                                variant="outline-secondary"
                                v-b-tooltip="'Make this report shareable by URL. Anyone who clicks the link can view and use all of it, even without a RiteTag account. (Cannot be undone)'"
                                v-on:click="publishReport(data.item)"
                        >Publish
                        </b-btn>
                        <b-btn
                                v-if="data.item.published"
                                variant="outline-secondary"
                                v-on:click="data.toggleDetails"
                        >{{ data.detailsShowing ? 'Hide' : 'Show' }} link
                        </b-btn>&nbsp;
                        <button class="btn btn-primary" @click="openReport(data.item.uuid)" v-if="data.item.status=='done'">
                            View report
                        </button>
                    </div>
                </template>
                <template v-slot:cell(row-details)="data">
                    <b-card>
                        <b-form-input
                                type="text"
                                class="link-input"
                                v-bind:value="protocol + '//' + hostname + '/instagram-coach-reports/' + data.item.uuid"
                        ></b-form-input>
                    </b-card>
                </template>
            </b-table>
        </b-container>

    </div>
</template>

<script>
    import {api} from "../_services"
    import InstagramModal from './reports/InstagramModal'
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: 'InstagramReports',
        components: {
            InstagramModal
        },
        data() {
            return {
                protocol: window.location.protocol,
                hostname: window.location.host,
                selectedHashtag: '',
                hashtagUrl: '',
                reportTableFields: [
                    'account',
                    'time_interval',
                    'price',
                    'status',
                    { key: 'publish', label: ''}
                ],
                reportData: [],
                editedReportData: []
            }
        },
        methods: {
            reload () {
                this.loadInstagramReports()
            },
            openReport (uuid) {
                this.$router.push('/instagram-coach-reports/'+uuid)
            },
            publishReport: function(item) {
                api.publishInstagramReport(item.uuid)
                    .then(response => {
                        item.published = true
                        this.$notify({
                            text: response.data.message
                        })
                    })
                    .catch(err => {
                        // todo
                    })
            },
            ...mapActions('reports', [
                'loadInstagramReports'
            ])
        },
        computed: {
            ...mapGetters('reports', [
                'getInstagramReports'
            ])
        },
        watch: {
            selectedHashtag: function () {
                this.hashtagUrl = `${process.env.RITETAG_URL}/hashtag-stats/` + this.selectedHashtag
            }
        },
        created() {
            this.loadInstagramReports()
        }
    }
</script>

<style scoped lang="scss">
    .link-input {
        width: 100%;
    }
    .arrow-top {
        margin-bottom: 8px;
        margin-left: 205px;
        vertical-align: text-bottom;
        height: 30px;
    }
    .try-me-out {
        margin-top: 4px;
        margin-right: 10px;
        color: $gray-500;
    }
</style>
